import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";
import mixpanel from "./mixpanel";
import VereV from "./components/LifeStack/LifeStack";
import CompoundInterestCalculator from "./components/CompoundInterestCalculator/CompoundInterestCalculator";
import GetOutOfDebt from "./components/GetOutOfDebt/GetOutOfDebt";
import CreateBudget from "./components/CreateBudget/CreateBudget";
import Invest from "./components/Invest/Invest";
import InvestingMindset from "./components/InvestingMindset/InvestingMindset";
import IndexInvesting from "./components/Books/IndexInvesting/IndexInvesting";
import Educational from "./components/Educational/Educational";
import GirlsAndFinances2025 from "./components/Books/GirlsAndFinances2025/GirlsAndFinances2025";
import FinancialLiteracy from "./components/Books/FinancialLiteracy/FinancialLiteracy";
import ScrollSnapScreen from "./components/NewApp/ScrollSnapScreen";
import Resources from "./components/Resources/Resources";
import KidsPage from "./components/Kids/KidsPage";
import YouthPage from "./components/Youth/YouthPage";
import Coaching from "./components/Coaching/Coaching";
import UntilYouSignTheLoan from "./components/Books/UntilYouSignTheLoan/UntilYouSignTheLoan";
import MoneyClarity from "./components/MoneyClarity/MoneyClarity";

const App: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    mixpanel.track("page_viewed", { page: location.pathname });
  }, [location.pathname]);

  return (
  <Routes>
    {/* Main routes */}
    <Route path="/" element={<ScrollSnapScreen />} />
    <Route path="/kids" element={<KidsPage />} />
    <Route path="/youth" element={<YouthPage />} />
    <Route path="/vereV" element={<VereV />} />
    <Route path="/resources" element={<Resources />} />
    <Route path="/coaching" element={<Coaching />} />

    {/* Calculators */}
    <Route path="/compound-interest-calculator" element={<CompoundInterestCalculator />} />
    <Route path="/money-clarity" element={<MoneyClarity />} />

    {/* Books */}
    <Route path="/index-investing" element={<IndexInvesting />} />
    <Route path="/until-you-sign-the-loan" element={<UntilYouSignTheLoan />} />
    <Route path="/girls-and-finances-wrapped-2025" element={<GirlsAndFinances2025 />} />
    <Route path="/financial-literacy" element={<FinancialLiteracy />} />

    {/* Educational content */}
    <Route path="/educational" element={<Educational />} />

    {/* Financial planning */}
    <Route path="/create-budget" element={<CreateBudget />} />
    <Route path="/get-out-of-debt" element={<GetOutOfDebt />} />
    <Route path="/invest" element={<Invest />} />
    <Route path="/investing-mindset" element={<InvestingMindset />} />
  </Routes>
  );
};

export default App;
